export const ENCODER_GUIDES = [
  {
    name: 'Any RTMP Encoder',
    img: '/img/source-vendors/rtmp.png',
    url: 'https://support.boxcast.com/en/articles/4235181',
  },
  {
    name: 'AJA HELO',
    img: '/img/source-vendors/AJA-HELO.png',
    url: 'https://support.boxcast.com/en/articles/4235194',
  },
  {
    name: 'Larix for Android',
    img: '/img/source-vendors/Larix.png',
    url: 'https://support.boxcast.com/en/articles/4235173',
  },
  {
    name: 'LiveU Solo',
    img: '/img/source-vendors/GoSolo.png',
    url: 'https://support.boxcast.com/en/articles/4235203',
  },
  {
    name: 'mimoLive',
    img: '/img/source-vendors/Mimo-Live.png',
    url: 'https://support.boxcast.com/en/articles/4235198',
  },
  {
    name: 'OBS',
    img: '/img/source-vendors/OBS.png',
    url: 'https://support.boxcast.com/en/articles/4235189',
  },
  {
    name: 'ProPresenter',
    img: '/img/source-vendors/ProPresenter.png',
    url: 'https://support.boxcast.com/en/articles/4632792',
  },
  {
    name: 'Sling Studio',
    img: '/img/source-vendors/SlingStudio.png',
    url: 'https://support.boxcast.com/en/articles/4235195',
  },
  {
    name: 'Switcher Studio',
    img: '/img/source-vendors/SwitcherStudio.png',
    url: 'https://support.boxcast.com/en/articles/4235196',
  },
  {
    name: 'Teradek',
    img: '/img/source-vendors/Teradek.png',
    url: 'https://support.boxcast.com/en/articles/4235192',
  },
  {
    name: 'vMix',
    img: '/img/source-vendors/Vmix.png',
    url: 'https://support.boxcast.com/en/articles/4235190',
  },
  {
    name: 'Wirecast',
    img: '/img/source-vendors/Wirecast.png',
    url: 'https://support.boxcast.com/en/articles/4235188',
  },
  {
    name: 'Zoom',
    img: '/img/source-vendors/Zoom.png',
    url: 'https://support.boxcast.com/en/articles/4235167',
  },
];

export const SOURCE_TABS = {
  free: [
    {
      tag: 'Recommended for Webcam',
      description:
        "BoxCast's <strong>Producer</strong> is a built-in video source that lets you use your browser as an encoder and stream with a webcam or capture device.",
      selectName: 'producer',
      selectParams: {
        action: 'openProducer',
      },
      imageURL: 'Video-Source_Producer.png',
      learnMoreURL: 'https://www.boxcast.com/platform/producer',
      action: 'openProducer',
    },
    {
      tag: 'Recommended for iOS',
      description:
        'Our <strong>Broadcaster app</strong> empowers you to stream, share, and monitor broadcasts from your iOS device.',
      selectName: 'broadcaster',
      selectParams: {
        action: 'downloadBroadcasterApp',
      },
      imageURL: 'Video-Source_BroadcasterApp.png',
      learnMoreURL: 'https://www.boxcast.com/product/broadcaster',
    },
    {
      description:
        'Through <strong>RTMP</strong> functionality, BoxCast lets you stream directly to our platform from your hardware or software encoder of choice, including <strong>OBS</strong>.',
      selectName: 'rtmp',
      selectParams: {},
      imageURL: 'Video-Source_RTMP.png',
      learnMoreURL: 'openRTMP',
    },
  ],
  boxcasters: [
    {
      tag: 'Recommended',
      description:
        'Our advanced <strong>BoxCaster Pro</strong> encoder seamlessly fits into your production workflow and lets you schedule, preview, simulcast, and monitor your broadcasts.',
      selectName: 'boxcaster-pro',
      selectParams: {},
      imageURL: 'Video-Source_BoxCasterPro.png',
      learnMoreURL: 'https://www.boxcast.com/product/boxcaster-pro',
    },
    {
      tag: 'Recommended',
      description:
        "The <strong>BoxCaster</strong> makes high-quality broadcasting super easy. Just plug in power, internet, and a camera, and you're ready to stream the crisp live video your viewers deserve!",
      selectName: 'boxcaster',
      selectParams: {},
      imageURL: 'Video-Source_BoxCaster.png',
      learnMoreURL: 'https://www.boxcast.com/product/boxcaster',
    },
  ],
  rtmp: [
    {
      tag: 'Popular',
      description:
        'BoxCast supports <strong>Wirecast</strong> by <strong>Telestream</strong> through an RTMP server URL and stream key.',
      selectName: 'rtmp',
      selectParams: { name: 'Wirecast' },
      imageURL: 'Wirecast.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235188',
    },
    {
      tag: 'Popular',
      description:
        'Use a <strong>Webcam and OBS</strong> (Open Broadcaster Software) and start streaming without spending a dime.',
      selectName: 'rtmp',
      selectParams: { name: 'OBS' },
      imageURL: 'OBS.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235189',
    },
    {
      tag: 'Popular',
      description:
        'BoxCast supports <strong>vMix</strong> by <strong>StudioCoast</strong> through an RTMP server URL and stream key.',
      selectName: 'rtmp',
      selectParams: { name: 'vMix' },
      imageURL: 'Vmix.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235190',
    },
    {
      tag: 'Popular',
      description:
        'BoxCast supports <strong>ProPresenter</strong> through an RTMP server URL and stream key.',
      selectName: 'rtmp',
      selectParams: { name: 'ProPresenter' },
      imageURL: 'ProPresenter.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4632792',
    },
    {
      description:
        'BoxCast supports the <strong>HELO</strong> encoder from <strong>AJA</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'AJA HELO' },
      imageURL: 'AJA-HELO.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235194',
    },
    {
      description:
        'BoxCast supports the <strong>VidiU</strong> and <strong>VidiU PRO</strong> by <strong>Teradek</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'Teradek VidiU' },
      imageURL: 'Teradek.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235192',
    },
    {
      description:
        'Stream <strong>Zoom</strong> conference calls between multiple people at your organization using BoxCast.',
      selectName: 'rtmp',
      selectParams: { name: 'Zoom' },
      imageURL: 'Zoom.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235167',
    },
    {
      description:
        '<strong>Switcher Studio</strong> from <strong>Switcher</strong> supports BoxCast within its app for iPhone and iPad.',
      selectName: 'rtmp',
      selectParams: { name: 'Switcher Studio' },
      imageURL: 'SwitcherStudio.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235196',
    },
    {
      description:
        '<strong>Larix Broadcaster</strong> from <strong>Softvelum</strong> is a free app for <strong>Android</strong> available on the Google Play store.',
      selectName: 'rtmp',
      selectParams: { name: 'Larix Broadcaster' },
      imageURL: 'Larix.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235173',
    },
    {
      description: '<strong>mimoLive</strong> supports BoxCast within its app.',
      selectName: 'rtmp',
      selectParams: { name: 'mimoLive' },
      imageURL: 'Mimo-Live.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235198',
    },
    {
      description:
        'BoxCast supports <strong>SlingStudio</strong> from <strong>Sling Media</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'SlingStudio' },
      imageURL: 'SlingStudio.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235195',
    },
    {
      description:
        'BoxCast supports the <strong>GoSolo</strong> from <strong>LiveU Solo</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'LiveU Solo' },
      imageURL: 'GoSolo.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235203',
    },
    {
      description:
        'BoxCast supports the <strong>LiveShell</strong> encoder from <strong>Cerevo</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'LiveShell' },
      imageURL: 'LiveShell.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235193',
    },
    {
      description:
        'BoxCast supports the <strong>ChurchStreamer</strong> from <strong>ChurchStreaming.tv</strong> through RTMP.',
      selectName: 'rtmp',
      selectParams: { name: 'ChurchStreamer' },
      imageURL: 'ChurchStreaming.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235204',
    },
    {
      description:
        'BoxCast supports <strong>AWS Elemental MediaLive</strong> from <strong>Amazon</strong> through an RTMP server URL and stream key.',
      selectName: 'rtmp',
      selectParams: { name: 'AWS Elemental Media Live' },
      imageURL: 'AWS-Elemental.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235199',
    },
    {
      description:
        'BoxCast supports <strong>Flash Media Live</strong> protocol from <strong>Adobe</strong> through an RTMP server URL and stream key.',
      selectName: 'rtmp',
      selectParams: { name: 'Flash Media Live' },
      imageURL: 'FMLE.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235202',
    },
    {
      description:
        'BoxCast lets you stream from your NewTek TriCaster, Teradek VidiU, SlingStudio, or other RTMP encoder.',
      selectName: 'rtmp',
      selectParams: { name: '' },
      imageURL: 'Video-Source_RTMP-Hardware.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235181',
    },
    {
      description:
        'With BoxCast, you can use Wirecast, OBS, MimoLive, Flash Media Live Encoder, or any other RTMP solution.',
      selectName: 'rtmp',
      selectParams: { name: '' },
      imageURL: 'Video-Source_RTMP-Software.png',
      learnMoreURL: 'https://support.boxcast.com/en/articles/4235181',
    },
  ],
};



// WEBPACK FOOTER //
// ./app/pages/sources/source-config.js